import dayjs from "dayjs";
import "dayjs/locale/de-ch";
import localizedFormat from "dayjs/plugin/localizedFormat";

export const dayjsSetup = async () => {
  dayjs.extend(localizedFormat);
  dayjs.locale("de-ch");
};

/**
 * Converts a time string into a formatted string.
 * @param time The time in the format ```HH:mm:ss``` important!
 * @param format The output format of the given time. Default: ```LT```
 * @returns A formatted string with the given time and format.
 */
export const formatTimeString = (time: string, format = "LT") => {
  return dayjs(`2000-01-01 ${time}`, "YYYY-MM-DD HH:mm:ss").format(format);
};
